import { USER_META_CURRENT_COOKIE_NAME } from '@/utils/constants';
import { UserMeta } from '@/integrations/tracking-service/cookies/type/UserMeta';

export function getCookieValue(name: string): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const prefix = `${name}=`;
  const found = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  if (!found) {
    return undefined;
  }

  return decodeURIComponent(found.substring(prefix.length));
}

/**
 * Reads umc cookie
 */
export function readUserMetaCurrentCookie(): UserMeta | undefined {
  const raw = getCookieValue(USER_META_CURRENT_COOKIE_NAME);

  if (!raw) {
    return undefined;
  }

  return JSON.parse(raw) as UserMeta;
}
